import { memo } from "react";
import styled from "styled-components";
import "./LoadMoreModal.css";

const Modal = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  z-index: 10;
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
`;

const ModalContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
`;

const SearchInput = styled.input`
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  height: 56px !important;
  font-weight: 400;
  line-height: 1.5;
  color: #ccc !important;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #f3f3f3 !important;
  border-radius: 13px !important;
`;

function LoadMoreModel({
  name,
  tableHeadings,
  masterData,
  isLoading,
  searchQuery,
  handleChangeSearchQuery,
  offset,
  limit,
  setOffset,
}) {
  const RenderBody = () => {
    if (isLoading && masterData?.length === 0) {
      return (
        <tr>
          <td colSpan={tableHeadings.length}>Loading...</td>
        </tr>
      );
    }
    if (masterData?.length > 0) {
      return masterData?.records.map((data) => (
        <tr key={`body-tr-key-${data.id}`}>
          {tableHeadings.map((item) => (
            <td key={`body-td-key-${data.id}-${item.name}`}>
              {item.fetchCustomData
                ? item.fetchCustomData(data, item)
                : data[item.value]}
            </td>
          ))}
        </tr>
      ));
    }
    if (masterData?.length === 0) {
      return (
        <tr>
          <td colSpan={tableHeadings.length}>No Data Found</td>
        </tr>
      );
    }
  };
  return (
    <>
      <Modal id={name}>
        <div className="modal-dialog modal-lg">
          <ModalContent>
            <div className="modal-header">
              <div className="w-100 justify-content-between align-items-center">
                <h1 className="col modal-title fs-5 ">Search</h1>
              </div>
              <div className="col d-flex justify-content-end">
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
            </div>
            <div className="modal-body load-more-modal">
              {/* <div className="container-fluid"> */}
              {/* search */}
              <div className="d-flex w-100 justify-content-end mb-5">
                <div className="w-50 row">
                  <div className="col-12">
                    <SearchInput
                      type="search"
                      className="w-100 "
                      placeholder="search"
                      value={searchQuery}
                      onChange={handleChangeSearchQuery}
                    />
                  </div>
                  <div className="col-12 d-flex justify-content-end mt-1">
                    <button
                      type="button"
                      className="border-0 mx-2"
                      onClick={() => setOffset(offset - 1)}
                    >
                      &lt;
                    </button>
                    {offset * limit + 1}-
                    {Math.min((offset + 1) * limit, masterData.length)} of{" "}
                    {masterData.length} items
                    <button
                      type="button"
                      className="border-0 mx-2"
                      onClick={() => setOffset(offset + 1)}
                    >
                      &gt;
                    </button>
                  </div>
                </div>
              </div>
              {/* table */}
              <table className="table table-bordered">
                <thead>
                  <tr>
                    {tableHeadings.map((item) => (
                      <th key={`head-key-${item.value}`} scope="col">
                        {item.name}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  <RenderBody />
                </tbody>
              </table>
              {/* </div> */}
            </div>
            <div className="modal-footer">footer</div>
          </ModalContent>
        </div>
      </Modal>
    </>
  );
}

export default memo(LoadMoreModel);
